import { render, staticRenderFns } from "./Arrange.vue?vue&type=template&id=a14cc0fe&scoped=true&"
import script from "./Arrange.vue?vue&type=script&lang=js&"
export * from "./Arrange.vue?vue&type=script&lang=js&"
import style0 from "./Arrange.vue?vue&type=style&index=0&id=a14cc0fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14cc0fe",
  null
  
)

export default component.exports